/**
 * Opens the shared lightbox for wiki-rendered post images. The Postimage
 * renderer (Objects/Text/Wiki/Render/Xhtml/Ifixit/Postimage.php) marks them
 * js-lightbox-image and carries the largest rendition as data-lightbox-src;
 * this binds the click side of that contract. Call it from every entry whose
 * page renders that markup — Answers, stories, and the dashboards that
 * inject Post HTML — binding is idempotent, so entries can overlap. One
 * delegated document listener covers content injected after page load.
 */
let bound = false;

export function bindLightboxImageClicks() {
   if (bound) {
      return;
   }
   bound = true;
   document.addEventListener('click', async event => {
      const img = event.target instanceof Element && event.target.closest('img.js-lightbox-image');
      if (!img || !(img instanceof HTMLImageElement) || !img.dataset.lightboxSrc) {
         return;
      }
      const { openImageLightbox } = await import('Shared/ImageLightbox');
      openImageLightbox(img.dataset.lightboxSrc);
   });
}
